"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashBoundParams = void 0;
const ethers_1 = require("ethers");
const utils_1 = require("../utils");
const abiCoder = ethers_1.AbiCoder.defaultAbiCoder();
function hashBoundParams(boundParams) {
    const hashed = (0, utils_1.keccak256)(abiCoder.encode([
        'tuple(uint16 treeNumber, uint48 minGasPrice, uint8 unshield, uint64 chainID, address adaptContract, bytes32 adaptParams, tuple(bytes32[4] ciphertext, bytes32 blindedSenderViewingKey, bytes32 blindedReceiverViewingKey, bytes annotationData, bytes memo)[] commitmentCiphertext) boundParams',
    ], [boundParams]));
    return (0, utils_1.hexToBigInt)(hashed) % utils_1.SNARK_PRIME_BIGINT;
}
exports.hashBoundParams = hashBoundParams;
